import React from 'react';

import { I18n } from 'aws-amplify';

import { Task } from '../../../utils/task';

import TextAreaField from '../../form/textarea-field';

import constants from '../../../constants';

import { scrollToTop } from '../../../utils/ui';

class CostForm extends React.Component {
    constructor(props) {

        super(props);

        const { bPitch = {} } = props;

        this.state = {
            fields: {
                additionalInfo: {
                    onChange: this.onChangeForm.bind(this, 'additionalInfo'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsOptional: true
                },
            },
            errors: {},
            form: { ...bPitch },
            task: {},
            submit_task: {}
        }
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const task = this.props.task || {};
        const prev = prevProps && prevProps.task || {};

        //console.dir({ task: task, prev: prev });

        if (task != prev) {

            var nextState = Object.assign({}, prevState, { task: task });

            const { bPitch = {} } = this.props;

            Object.keys(this.state.fields).forEach((item) => {

                if (bPitch[item]) {
                    nextState.form[item] = bPitch[item];
                }

            });

            this.setState(nextState);
        }
    }

    onChangeForm(prop, e) {

        const value = e.target.value;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving() );
    }

    getData() {

        var data = {
            projectId: this.props.match.params.projectId,
            ...this.props.bPitch,
            ...this.state.form
        };

        return data;
    }

    onSaving(){

        clearTimeout(this.t);
        this.t = setTimeout(() => this.onSave(), 1000)
    }

    onSave() {

        var submit_task = new Task();

        submit_task.start();

        this.setState({ submit_task: submit_task });

        this.props.update_bpitch(this.getData())
            .then(({ task, errors }) => {

                this.setState({ submit_task: task, errors: errors });
            });
    }

    render() {

        return (
            <div>

                <h1 className="title-bpool medium">{I18n.get("Informações Adicionais")}</h1>

                <div className="bp-event-section" style={{ marginTop: '3rem', maxWidth: '40rem' }}>

                    <TextAreaField 
                    {...this.state.fields.additionalInfo} 
                    label={I18n.get("Adicione quaisquer informações adicionais sobre sua marca, produto ou serviço")}
                    value={this.state.form.additionalInfo} 
                    error={this.state.errors.additionalInfo} />

                    <br />

                </div>
            </div>
        );
    }
}

export default CostForm;
